import './footer.css';


export default function Footer() {
  return (
    <nav className="footer">
      <div className="container" style={{ color: '#00774f', padding: 5 }}>
        Brenda
        <span style={{ color: '#bb823f' }}> & </span>
        Uriel
      </div>
      <div className="bidev" style={{ color: '#00774f', padding: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        Powered By&nbsp;
        <img alt='bidevmx' style={{ color: 'rgb(102, 45, 128)', cursor: 'pointer', maxHeight: 30 }} onClick={() => window.open('https://bidev.mx/')} src={process.env.PUBLIC_URL + '/assets/logo_bidev_.png'} loading="lazy" />

      </div>
    </nav>
  );
}

